module.exports = __webpack_public_path__ + "media/hallBgm.cd261a9e.mp3";